import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { DocumentService } from 'src/app/application/service/DocumentService';
import { ExportOffer } from 'src/app/domain/models/ExportOffer';
import { ImportOrder, ImportOrderDetail } from 'src/app/domain/models/ImportOrder';
import { Packaging } from 'src/app/domain/models/Packaging';
import { ProductCertificateType } from 'src/app/domain/models/ProductCertificateType';
import { BasicUser } from 'src/app/domain/models/User';
import { ExportOfferUtils } from 'src/app/ui/util/export-offer-utils';
import { Lang } from 'src/app/ui/util/langs';

@Component({
  selector: 'app-export-offer-detail',
  templateUrl: './export-offer-detail.component.html',
  styleUrls: ['./export-offer-detail.component.css']
})
export class ExportOfferDetailComponent implements OnInit {

  @Input()
  offer: ExportOffer | undefined


  @Input()
  productCertificateTypes: ProductCertificateType[] = []

  @Input()
  packagingTypes: Packaging[] = []

  profile: BasicUser | undefined

  @Input()
  importOrder: ImportOrder | undefined

  @Input()
  suggestedPrice: number | undefined

  @Input()
  typeSale: string | undefined

  negotiationPrice: number | undefined
  negotiationIncoterms: string | undefined

  itemFinded: ImportOrderDetail[] | undefined

  totalPrice: number = 0
  urlRoute: string = ''

  markTrue: string = ''



  constructor(
    private _authService: AuthGateway,
    public translate: TranslateService,
    private _documentService: DocumentService,

  ) {
    this.profile = _authService.getUser()
  }

  ngOnInit(): void {
    this.urlRoute = window.location.href;
  }

  getHeader(): string {
    let header = ''
    if(this.profile)
    {
      switch(this.profile.lang) {
        case 'en':
          header = this.offer?.variety && this.offer.variety.species && this.offer.variety.species.name ? this.offer.variety.species.name.toUpperCase() : ''
          this.markTrue = 'Yes'
          break

        case 'es':
          header = this.offer?.variety && this.offer.variety.species && this.offer.variety.species.nameEs ? this.offer.variety.species.nameEs.toUpperCase() : ''
          this.markTrue = 'Si'
          break
      }
    }
    return header
  }

  getSubheader(): string {
    return this.offer?.variety && this.offer.variety.name ? this.offer.variety.name.toUpperCase() : ''
  }

  get finalPaymentSubjectQC(): number {
    if(this.offer && this.offer.paymentAgainstBL)
      return 100 - this.offer.paymentAgainstBL
    return 0
  }

  getNegotiationPrice(): boolean {
    if (this.offer?.orderDetailsRelations && this.importOrder?.guid) {
      this.itemFinded = this.offer?.orderDetailsRelations.filter(item => item.importOrder.guid == this.importOrder?.guid)

      if (this.itemFinded && this.itemFinded.length > 0) {
        this.negotiationPrice = this.itemFinded[0].price ?? undefined
        this.negotiationIncoterms = this.itemFinded[0].incoterms ?? undefined

        // Se verifica si el valor o el Incoterms son diferentes para que gráficamente muestre que hubo negociación de precios
        if ((this.negotiationPrice && (this.negotiationPrice !== this.offer.listPrice)) || (this.negotiationIncoterms && (this.negotiationIncoterms !== this.offer.typeSale))) return true
      }
    }
    return false
  }


  get speciesDescription() {
    if(this.offer) {

      switch(this.translate.currentLang) {
        case 'en':
          return {
            description: this.offer.variety?.species?.descriptionEn,
            technicalCharacteristics: this.offer.variety?.species?.technicalCharacteristicsEn,
            qualityControlCriteria: this.offer?.variety?.species?.qualityControlCriteriaEn,
            harvestAreaChile: this.offer?.variety?.species?.harvestAreaChileEn
          }
          break
        case 'es':
          return  {
            description: this.offer.variety?.species?.descriptionEs,
            technicalCharacteristics: this.offer.variety?.species?.technicalCharacteristicsEs,
            qualityControlCriteria: this.offer?.variety?.species?.qualityControlCriteriaEs,
            harvestAreaChile: this.offer?.variety?.species?.harvestAreaChileEs
          }
          break
      }
    }
    return  {
      description: this.getAvailableLabel(),
      technicalCharacteristics: this.getAvailableLabel(),
      qualityControlCriteria: this.getAvailableLabel(),
      harvestAreaChile: this.getAvailableLabel()
    }
  }

  getAvailableLabel() {
    return this.translate.instant('ExportOffer.ExportOfferDetail.NoAvailable')
  }

  getNoAvailableLabel() {
    return this.translate.instant('ExportOffer.ExportOfferDetail.NoAvailable')
  }


  getIncoterms(value: string) {
    return ExportOfferUtils.getIncotermsName(value)
  }

  getTotalPriceOfferDialog(value: number) {
    if(this.offer && value){
      this.totalPrice = ExportOfferUtils.getTotalPrice(this.offer,value)
    }
  }

  getPackagingTypes(packagingTypes: Packaging[])
  {
    let name = '';
    if(packagingTypes.length == 1)
      {
        return packagingTypes[0].name;
      }
      packagingTypes.forEach((x, index) => {
      if(index == 0)
        {
          name = name + x.name;
        }else{
          name =  name + '/' + x.name;
        }
    }
    );
    return name
  }

  getCertificatesName(certificates: ProductCertificateType[]): string
  {
    let name = '';
    if(certificates.length == 1)
      {
        return certificates[0].name;
      }
    certificates.forEach((x, index) => {
      if(index == 0)
        {
          name = name + x.name;
        }else{
          name =  name + '/' + x.name;
        }
    }
    );
    return name
  }

  getBoxType(boxType?: string): string {
    return this.profile ? ExportOfferUtils.getBoxTypeName(this.profile.lang, boxType) : ''
  }

  getBasePallets(basePallets?: string) {
    return this.profile ? ExportOfferUtils.getBasePalletsName(this.profile.lang, basePallets) : ''
  }

  getExportOfferQualityDocument(documents: any[] | undefined) {
    if (documents == undefined || documents.length <= 0) return;

    let docId = documents[0].id

    this._documentService.getExportOfferDocument2(docId).subscribe((resultBlob: any) => {
      var downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);})
  }

}

